import * as monaco from 'monaco-editor/esm/vs/editor/editor.main.js';
window.monaco = monaco;

// somehow esm doesn't work here...
import { DefaultRubyVM } from "@ruby/wasm-wasi/dist/browser.umd.js";
import rubySource from "bundle-text:./index.rb";
import rubyWasmURL from "url:../ruby.wasm";

const parsedRubyWasmURL = URL.parse(rubyWasmURL);
if (process.env.RUBY_WASM_URL_HOST) {
    parsedRubyWasmURL.host = process.env.RUBY_WASM_URL_HOST;
}

class CallbackStreamSource {
    constructor(stream, callback) {
        this.stream = stream;
        this.callback = callback;
    }

    async start(controller) {
        this.reader = this.stream.getReader();
        this.pull(controller);
    }

    async pull(controller) {
        const result = await this.reader.read();
        if (result.done) {
            controller.close();
            return;
        }
        this.callback(result.value);
        controller.enqueue(result.value);
    }
}

function wrapResponseWithProgress(response, callback) {
    const total = response.headers.get('content-length');
    let loaded = 0;
    const stream = new ReadableStream(new CallbackStreamSource(response.body, (chunk) => {
        loaded += chunk.length;
        callback(loaded, total);
    }));
    const newResponse = new Response(stream);
    for (let pair of response.headers.entries()) {
        newResponse.headers.set(pair[0], pair[1]);
    }
    return newResponse;
}

fetch(parsedRubyWasmURL)
  .then((response) => {
    const percentElement = document.getElementById('percent');
    return wrapResponseWithProgress(response, (loaded, total) => {
        percentElement.innerText = Math.round(loaded/total * 100).toString();
    });
  })
  .then((response) => WebAssembly.compileStreaming(response))
  .then((module) => DefaultRubyVM(module))
  .then(({ vm }) => vm.evalAsync(rubySource));
